<template>
    <div>
        <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
        <el-button class="to-bottom" circle icon="el-icon-caret-bottom" @click="scrollToBottom"></el-button>
        <el-backtop></el-backtop>
        <div v-loading="loading" class="container py-2">
            <b class="fs-20 py-2 d-block">选择联赛：</b>
            <!--选择更新-->
            <div class="d-flex flex-column">
                <label class="selection-checkbox select-all">
                    <input
                        type="checkbox"
                        :checked="checkAll"
                        @change="handleCheckAllChange($event.target.checked)"
                    >
                    <span
                        class="checkbox-icon"
                        :class="{
                            'is-checked': checkAll,
                            'is-indeterminate': isIndeterminate
                        }"
                    ></span>
                    <span>全选</span>
                </label>
                <div>
                    <label v-for="(item,index) in fbLeagues" :key="index" class="selection-checkbox league-checkbox mt-2">
                        <input
                            type="checkbox"
                            :checked="isLeagueChecked(item)"
                            @change="handleLeagueChange(item, $event.target.checked)"
                        >
                        <span class="checkbox-icon" :class="{ 'is-checked': isLeagueChecked(item) }"></span>
                        <span>{{item.name}}</span>
                    </label>
                </div>
            </div>
            <!--按钮-->
            <div class="mt-4 text-center">
                <el-button type="info" v-loading.fullscreen.lock="loading" @click="crawlerCheckLeague">获取联赛列表</el-button>
                <el-button type="primary" :loading="this.atrDefUpdateLoading" :disabled="this.atrDefUpdateDialogVisible" @click="updateFbLgData">更新攻防数据</el-button>
                    <el-dialog
                        title="更新攻防数据"
                        :visible.sync="atrDefUpdateDialogVisible"
                        width="420px"
                        :close-on-click-modal="!atrDefUpdateLoading"
                        :close-on-press-escape="!atrDefUpdateLoading"
                        :show-close="!atrDefUpdateLoading"
                        center
                    >
                        <div v-if="atrDefUpdateLoading">
                            <p class="text-center">正在更新 {{ atrDefUpdateCurrentName }}（{{ atrDefUpdateCompleted }} / {{ atrDefUpdateTotal }}）</p>
                            <el-progress :percentage="atrDefUpdateProgress"></el-progress>
                            <p class="text-center mb-0">成功 {{ atrDefUpdateSuccess }}，失败 {{ atrDefUpdateFailed }}，跳过 {{ atrDefUpdateSkipped }}</p>
                        </div>
                        <p v-else class="text-center mb-0">{{ atrDefUpdateResult }}</p>
                        <span v-if="!atrDefUpdateLoading" slot="footer">
                            <el-button type="primary" @click="atrDefUpdateDialogVisible = false">确 定</el-button>
                        </span>
                    </el-dialog>
            </div>
            <div class="mt-4">
            <el-tabs
                v-model="activeName"
                class="update-tabs"
                :class="{ 'is-dark': isDark }"
                @tab-click="tabsClick"
            >
                <!--修改/增减联赛-->
                <el-tab-pane label="修改/增减联赛" name="first">
                    <ux-grid ref="plxTable" stripe show-overflow use-virtual :data = fbLeagues :highlightCurrentRow="true" :checkboxConfig="{highlight: true}" :edit-config="{trigger: 'click', mode: 'cell'}">
                        <ux-table-column field="lid" title="联赛id" edit-render :width="isMobile ? 80 : ''">
                            <template v-slot:edit="scope">
                                <el-input v-model="scope.row.lid"></el-input>
                            </template>
                        </ux-table-column>
                        <ux-table-column field="name" title="联赛名" edit-render>
                            <template v-slot:edit="scope">
                                <el-input v-model="scope.row.name"></el-input>
                            </template>
                        </ux-table-column>
                        <ux-table-column field="tag" title="标签" edit-render>
                            <template v-slot:edit="scope">
                                <el-input v-model="scope.row.tag"></el-input>
                            </template>
                        </ux-table-column>
                        <ux-table-column field="continents" title="大洲" edit-render>
                            <template v-slot:edit="scope">
                                <el-input v-model="scope.row.continents"></el-input>
                            </template>
                        </ux-table-column>
                        <ux-table-column field="country" title="国家" edit-render>
                            <template v-slot:edit="scope">
                                <el-input v-model="scope.row.country"></el-input>
                            </template>
                        </ux-table-column>
                        <ux-table-column field="api_id" title="API ID" edit-render>
                            <template v-slot:edit="scope">
                                <el-input v-model="scope.row.api_id"></el-input>
                            </template>
                        </ux-table-column>
                        <ux-table-column title="操作" field="detail" :width="70" fixed="right">
                            <template v-slot="scope">
                                <a class="text-primary pointer" @click="removeSelected(scope.row)">删除</a>
                            </template>
                        </ux-table-column>
                    </ux-grid>
                    <div class="w-100 text-end py-2">
                        <el-button @click="insertEvent(-1)">新增联赛</el-button>
                        <el-button @click="saveChg">保存修改</el-button>
                    </div>
                </el-tab-pane>
                <!--修改球队名称-->
                <el-tab-pane label="队名增加/修改" name="second">
                    <div class="d-flex justify-content-center align-items-start flex-wrap">
                        <el-input
                            placeholder="按球队ID搜索..."
                            v-model="teamId"
                            class="input-with-select mb-3 team-search-input"
                            clearable
                            @keyup.enter.native="searchId"
                        >
                            <el-button slot="append" icon="el-icon-search" @click="searchId"></el-button>
                        </el-input>
                        <el-dropdown
                            trigger="click"
                            placement="bottom-start"
                            class="team-league-dropdown mb-3"
                            @visible-change="handleLeagueDropdownChange"
                            @command="handleLeagueCommand"
                        >
                            <el-input
                                placeholder="按联赛搜索球队..."
                                v-model="teamLeagueQuery"
                                class="input-with-select"
                                clearable
                                @input="searchLeague"
                            ></el-input>
                            <el-dropdown-menu slot="dropdown" class="dropdown-menu-content">
                                <el-dropdown-item v-if="leagueListLoading" disabled>正在加载联赛列表...</el-dropdown-item>
                                <el-dropdown-item
                                    v-for="(league, index) in filteredFbLeagues"
                                    :key="`${league.lid}-${index}`"
                                    :command="league"
                                >{{ league.name }}</el-dropdown-item>
                                <el-dropdown-item v-if="leagueListError" disabled>联赛列表加载失败</el-dropdown-item>
                                <el-dropdown-item v-if="noLeagueResults" disabled>无搜索结果</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div v-loading="teamSearchLoading">
                        <el-alert
                            v-if="teamSearchError"
                            class="mb-2"
                            title="球队查询失败"
                            type="error"
                            :closable="false"
                        ></el-alert>
                        <ux-grid
                            ref="teamTable"
                            stripe
                            show-overflow
                            use-virtual
                            :data="teams"
                            :highlightCurrentRow="true"
                            :checkboxConfig="{highlight: true}"
                            :edit-config="{trigger: 'click', mode: 'cell'}"
                            show-header-overflow="ellipsis"
                        >
                            <ux-table-column type="checkbox" :width="40"/>
                            <ux-table-column
                                v-for="field in teamFields"
                                :key="field"
                                :field="field"
                                :title="field"
                                edit-render
                            >
                                <template v-slot:edit="scope">
                                    <el-input v-model="scope.row[field]"></el-input>
                                </template>
                            </ux-table-column>
                        </ux-grid>
                        <div class="w-100 text-end py-2">
                            <el-button :loading="teamSaveLoading" @click="saveSelectedTeams">保存修改</el-button>
                        </div>
                    </div>
                    <el-dialog
                        title="保存球队修改"
                        :visible.sync="teamSaveDialogVisible"
                        width="360px"
                        :close-on-click-modal="!teamSaveLoading"
                        :close-on-press-escape="!teamSaveLoading"
                        :show-close="!teamSaveLoading"
                        center
                    >
                        <div v-if="teamSaveLoading">
                            <p class="text-center">正在保存 {{ teamSaveCompleted }} / {{ teamSaveTotal }} 条</p>
                            <el-progress :percentage="teamSaveProgress"></el-progress>
                        </div>
                        <p v-else class="text-center mb-0">{{ teamSaveResult }}</p>
                        <span v-if="!teamSaveLoading" slot="footer">
                            <el-button type="primary" @click="teamSaveDialogVisible = false">确 定</el-button>
                        </span>
                    </el-dialog>

                </el-tab-pane>
                <!--查询接口-->
                <el-tab-pane label="查询接口数据" name="third">
                    <div class="d-flex flex-wrap align-items-start">
                        <el-dropdown trigger="click" placement="bottom-start" class="mb-3 api-search-dropdown" @command="handleCommand" @visible-change="handleCountryDropdownChange">
                            <el-input placeholder="搜索国家名(英文)..." v-model="country" class="input-with-select" @input="searchCountry" clearable>
                            </el-input>
                            <el-dropdown-menu slot="dropdown" class="dropdown-menu-content">
                                <el-dropdown-item v-if="countriesLoading" disabled>正在加载国家列表...</el-dropdown-item>
                                <el-dropdown-item
                                    v-for="(item,index) in filteredCountries"
                                    :key="index"
                                    :command="item"
                                >
                                    <span class="country-option">
                                        <span class="country-flag-box">
                                            <img
                                                v-if="item.flag"
                                                class="country-flag"
                                                :src="item.flag"
                                                :alt="`${item.value} flag`"
                                                @error="handleCountryFlagError"
                                            >
                                        </span>
                                        <span>{{ item.value }}</span>
                                    </span>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="noRes" disabled>无搜索结果</el-dropdown-item>
                                <el-dropdown-item v-if="countryLoadError" disabled>国家列表加载失败</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-dropdown
                            trigger="click"
                            placement="bottom-start"
                            class="mb-3 api-search-dropdown"
                            :class="{ 'is-disabled': apiLeagues.length === 0 }"
                            @command="handleApiLeagueCommand"
                        >
                            <el-input
                                placeholder="搜索联赛名..."
                                v-model="apiLeagueQuery"
                                class="input-with-select"
                                :disabled="apiLeagues.length === 0"
                                @input="searchApiLeague"
                                clearable
                            ></el-input>
                            <el-dropdown-menu slot="dropdown" class="dropdown-menu-content">
                                <el-dropdown-item
                                    v-for="(league, index) in filteredApiLeagues"
                                    :key="`${league.id}-${index}`"
                                    :command="league"
                                >
                                    <span class="country-option">
                                        <span class="league-logo-box">
                                            <img
                                                v-if="league.logo"
                                                class="league-logo"
                                                :src="league.logo"
                                                :alt="`${league.name} logo`"
                                                @error="handleLeagueLogoError"
                                            >
                                        </span>
                                        <span>{{ league.name }}</span>
                                    </span>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="apiLeagues.length > 0 && filteredApiLeagues.length === 0" disabled>无搜索结果</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="api-league-tables">
                        <div class="api-league-table" v-loading="apiLeaguesLoading">
                            <el-alert
                                v-if="apiLeaguesError"
                                class="mb-2"
                                title="获取该国家的联赛列表失败"
                                type="error"
                                :closable="false"
                            ></el-alert>
                            <el-table
                                :data="apiLeagues"
                                border
                                stripe
                                style="width: 100%"
                                :empty-text="apiLeagues.length ? '暂无联赛数据' : '请选择国家以加载联赛数据'"
                            >
                                <el-table-column type="index" label="#" width="40"></el-table-column>
                                <el-table-column prop="id" label="联赛id" width="65"></el-table-column>
                                <el-table-column label="图标" width="60" align="center">
                                    <template slot-scope="scope">
                                        <span class="league-logo-box">
                                            <img
                                                v-if="scope.row.logo"
                                                class="league-logo"
                                                :src="scope.row.logo"
                                                :alt="`${scope.row.name} logo`"
                                                @error="handleLeagueLogoError"
                                            >
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name" label="联赛名" min-width="" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="type" label="类型" width="80"></el-table-column>
                                <el-table-column label="积分榜" width="65">
                                    <template slot-scope="scope">
                                        {{ scope.row.standing === true ? '有' : scope.row.standing === false ? '无' : '暂无数据' }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="api-standings-table" v-loading="apiStandingsLoading">
                            <el-alert
                                v-if="apiStandingsError"
                                class="mb-2"
                                title="获取联赛积分榜失败"
                                type="error"
                                :closable="false"
                            ></el-alert>
                            <el-table
                                :data="apiStandings"
                                border
                                stripe
                                style="width: 100%"
                                :empty-text="selectedApiLeague ? '该联赛暂无积分榜数据' : '请选择联赛查看积分榜'"
                            >
                                <el-table-column prop="rank" label="排名" width="50"></el-table-column>
                                <el-table-column prop="teamId" label="ID" width="60"></el-table-column>
                                <el-table-column label="球队" min-width="180">
                                    <template slot-scope="scope">
                                        <span class="standings-team">
                                            <span class="standings-team-logo-box">
                                                <img
                                                    v-if="scope.row.teamLogo"
                                                    class="standings-team-logo"
                                                    :src="scope.row.teamLogo"
                                                    :alt="`${scope.row.team} logo`"
                                                    @error="handleLeagueLogoError"
                                                >
                                            </span>
                                            <span>{{ scope.row.team }}</span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="played" label="已赛" width="50"></el-table-column>
                                <el-table-column prop="goalsFor" label="进球" width="50"></el-table-column>
                                <el-table-column prop="goalsAgain" label="失球" width="50"></el-table-column>
                                <el-table-column prop="point" label="积分" width="50"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <!-- <el-input placeholder="搜索国家(英文)..." v-model="teamId" class="input-with-select mb-3 w-25" clearable>
                        <el-button slot="append" icon="el-icon-search" @click="searchId"></el-button>
                    </el-input> -->
                </el-tab-pane>
                <!-- <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
            </el-tabs>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Nav from '../components/comment/nav.vue'
import Footer from '../components/comment/footer.vue'
import { crawlerCheckLeagueUrl, getFbCheckLeagueUrl, getFbSelectedLeaguesUrl, updateAtrDefUrl,getApiCountryListUrl, updateSelectedLeaguesUrl, findTeamByIdUrl, findTeamByLidUrl, updateApiTeamUrl, getApiLeaguesByCountryCodeUrl, getApiStandingsUrl } from '../constants/http.config.js';
import { checkDevice } from '../utils/utils.js';
export default {
    components: { Nav,Footer },
    data(){
        return {
            loading: true,
            isDark: false,
            isIndeterminate: false,
            checkAll: false,
            isMobile: false,
            countriesLoading: false,
            countriesLoaded: false,
            countryLoadError: false,
            apiLeaguesLoading: false,
            apiLeaguesError: false,
            apiLeagueRequestId: 0,
            apiStandings: [],
            apiStandingsLoading: false,
            apiStandingsError: false,
            apiStandingsRequestId: 0,
            selectedApiLeague: '',
            teamLeagueQuery: '',
            teams: [],
            teamSearchLoading: false,
            teamSearchError: false,
            teamSearchAttempted: false,
            teamSearchRequestId: 0,
            teamSaveLoading: false,
            atrDefUpdateLoading: false,
            atrDefUpdateDialogVisible: false,
            atrDefUpdateCompleted: 0,
            atrDefUpdateTotal: 0,
            atrDefUpdateSuccess: 0,
            atrDefUpdateFailed: 0,
            atrDefUpdateSkipped: 0,
            atrDefUpdateCurrentName: '',
            atrDefUpdateResult: '',
            atrDefUpdateErrors: [],
            teamSaveDialogVisible: false,
            teamSaveCompleted: 0,
            teamSaveTotal: 0,
            teamSaveSuccess: 0,
            teamSaveFailed: 0,
            teamSaveResult: '',
            countryQuery: '',
            apiLeagueQuery: '',
            selectedLeagueNames: new Set(),
            selectionVersion: 0,
            checkedCount: 0,
            activeName: 'first',
            leagueListLoading: false,
            leagueListError: false,
            teamName: '',
            teamId: '',
            country: '',
            fbLeagues: [],
            countries: [],
            apiLeagues: [],
        }
    },
    computed: {
        filteredCountries(){
            const query = this.countryQuery.trim().toLowerCase();
            if (!query) {
                return this.countries;
            }
            return this.countries.filter(item => item.value.toLowerCase().includes(query));
        },
        filteredApiLeagues(){
            const query = this.apiLeagueQuery.trim().toLowerCase();
            if (!query) {
                return this.apiLeagues;
            }
            return this.apiLeagues.filter(item =>
                String(item.name || '').toLowerCase().includes(query)
            );
        },
        noRes(){
            return this.countriesLoaded &&
                !this.countriesLoading &&
                !this.countryLoadError &&
                this.filteredCountries.length === 0;
        },
        filteredFbLeagues(){
            const query = this.teamLeagueQuery.trim().toLowerCase();
            if (!query) {
                return this.fbLeagues;
            }
            return this.fbLeagues.filter(league =>
                String(league.name || '').toLowerCase().includes(query)
            );
        },
        noLeagueResults(){
            return !this.loading &&
                !this.leagueListLoading &&
                !this.leagueListError &&
                this.filteredFbLeagues.length === 0;
        },
        teamFields(){
            return Array.from(new Set(this.teams.reduce((fields, team) => {
                return fields.concat(Object.keys(team).filter(field =>
                    field !== 'createdAt' && field !== 'updatedAt'
                ));
            }, [])));
        },
        teamSaveProgress(){
            return this.teamSaveTotal
                ? Math.floor(this.teamSaveCompleted / this.teamSaveTotal * 100)
                : 0;
        },
        atrDefUpdateProgress(){
            return this.atrDefUpdateTotal
                ? Math.floor(this.atrDefUpdateCompleted / this.atrDefUpdateTotal * 100)
                : 0;
        }
    },
    async mounted() {
        await this.getFbSelectedLeagues();
        await this.getCheckLeague();
        this.isMobile = checkDevice();
    },
    methods: {
        scrollToBottom(){
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        },
        //获取足球联赛列表
        async getFbSelectedLeagues(){
            const url = getFbSelectedLeaguesUrl;
            this.leagueListLoading = true;
            this.leagueListError = false;
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`Football league list request failed: ${response.status}`);
                }
                const data = await response.json();
                if (!Array.isArray(data.data)) {
                    throw new Error('Football league list response is invalid');
                }
                this.fbLeagues = data.data;
            } catch (err) {
                this.leagueListError = true;
                console.log(err);
            } finally {
                this.leagueListLoading = false;
                this.loading = false;
            }
        },
        handleCheckAllChange(val){
            this.checkAll = val;
            this.selectedLeagueNames = val
                ? new Set(this.fbLeagues.map(item => item.name))
                : new Set();
            this.selectionVersion++;
            this.checkedCount = val ? this.fbLeagues.length : 0;
            this.isIndeterminate = false;
        },
        isLeagueChecked(item){
            // Read the revision so Vue refreshes native checkbox bindings after Set mutations.
            this.selectionVersion;
            return this.selectedLeagueNames.has(item.name);
        },
        handleLeagueChange(item, checked){
            if (checked) {
                this.selectedLeagueNames.add(item.name);
            } else {
                this.selectedLeagueNames.delete(item.name);
            }
            this.selectionVersion++;
            this.checkedCount += checked ? 1 : -1;
            this.checkAll = this.fbLeagues.length > 0 && this.checkedCount === this.fbLeagues.length;
            this.isIndeterminate = this.checkedCount > 0 && this.checkedCount < this.fbLeagues.length;
        },
        async getCheckLeague(){
            const url = getFbCheckLeagueUrl;
            try {
                const response = await fetch(url);
                const data = await response.json();
                const selectedLeagueNames = data.data[0].data;
                const selectedNames = new Set(selectedLeagueNames);
                this.selectedLeagueNames = new Set(
                    this.fbLeagues
                        .map(item => item.name)
                        .filter(name => selectedNames.has(name))
                );
                this.selectionVersion++;
                this.checkedCount = this.selectedLeagueNames.size;
                this.checkAll = this.fbLeagues.length > 0 && this.checkedCount === this.fbLeagues.length;
                this.isIndeterminate = this.checkedCount > 0 && this.checkedCount < this.fbLeagues.length;
            } catch (err) {
                console.log(err);
            }
        },
        //获取要抓取的联赛
        crawlerCheckLeague(){
            this.loading = true;
            const url = crawlerCheckLeagueUrl;
            fetch(url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.getCheckedLeagues())
                })
                .then(response => response.json())
                .then(data => {
                    if (data.code == 200) {
                        this.$notify({
                            title: '抓取成功',
                            message: data.data,
                            type: 'success',    
                            // duration: 0
                        });
                    } else {
                        this.$notify.error({
                            title: '抓取失败',
                            message: '请检查代码',
                            // duration: 0
                        });
                    }
                    console.log(data);
                    this.loading = false;
                }).catch(err=>{
                    this.loading = false;
                    this.$notify.error({
                            title: '抓取失败',
                            message: '未知错误，请重试',
                        });
                    console.error(err);
                })
        },
        getCheckedLeagues(){
            return this.fbLeagues.filter(item => this.selectedLeagueNames.has(item.name));
        },
        async updateFbLgData(){
            if (this.atrDefUpdateLoading) {
                return;
            }
            const selectedLeagues = this.getCheckedLeagues();
            if (selectedLeagues.length === 0) {
                this.$message.error('请至少选中一个联赛!');
                this.loading = false;
                return;
            }

            const groupsByKey = new Map();
            for (const league of selectedLeagues) {
                const key = String(league.tag) + ':' + String(league.lid);
                if (!groupsByKey.has(key)) {
                    groupsByKey.set(key, []);
                }
                groupsByKey.get(key).push(league);
            }
            const leagueGroups = Array.from(groupsByKey.values());

            this.atrDefUpdateLoading = true;
            this.atrDefUpdateDialogVisible = true;
            this.atrDefUpdateCompleted = 0;
            this.atrDefUpdateTotal = leagueGroups.length;
            this.atrDefUpdateSuccess = 0;
            this.atrDefUpdateFailed = 0;
            this.atrDefUpdateSkipped = 0;
            this.atrDefUpdateCurrentName = '';
            this.atrDefUpdateResult = '';
            this.atrDefUpdateErrors = [];

            try {
                for (const group of leagueGroups) {
                    const league = group[0];
                    const displayName = group.map(item => item.name).join(' / ');
                    this.atrDefUpdateCurrentName = displayName;
                    const requestData = group.length > 1
                        ? Object.assign({}, league, { groupedLeagues: group })
                        : league;

                    try {
                        const response = await fetch(updateAtrDefUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(requestData)
                        });
                        const result = await response.json();
                        console.log(result);
                        
                        if (!response.ok || result.code !== 200 || !result.data) {
                            throw new Error(result.data && result.data.error
                                ? result.data.error
                                : 'Request failed: ' + response.status);
                        }

                        const data = result.data;
                        const succeeded = Number(data.succesed) || 0;
                        const failed = data.failed ? Number(data.failed.num) || 0 : 0;
                        this.atrDefUpdateSuccess += succeeded;
                        this.atrDefUpdateFailed += failed;
                        if (data.skipped) {
                            this.atrDefUpdateSkipped += Number(data.skipped) || 1;
                        }
                        if (succeeded === 0 && failed === 0 && !data.skipped) {
                            this.atrDefUpdateFailed++;
                            this.atrDefUpdateErrors.push(displayName + ': 未返回成功、失败或跳过状态');
                        }
                        if (data.failed && Array.isArray(data.failed.list) && data.failed.list.length > 0) {
                            this.atrDefUpdateErrors.push(displayName + '(' + data.failed.list.map(item => item.lid).join('、') + ')');
                        }
                    } catch (err) {
                        this.atrDefUpdateFailed++;
                        this.atrDefUpdateErrors.push(displayName + ': ' + err.message);
                        console.error('League attack/defense update failed', requestData, err);
                    } finally {
                        this.atrDefUpdateCompleted++;
                    }
                }
            } finally {
                this.atrDefUpdateLoading = false;
                this.atrDefUpdateCurrentName = '';
            }

            const summary = '处理完成：成功 ' + this.atrDefUpdateSuccess + ' 个，失败 ' +
                this.atrDefUpdateFailed + ' 个，跳过 ' + this.atrDefUpdateSkipped + ' 个。';
            this.atrDefUpdateResult = this.atrDefUpdateErrors.length
                ? summary + '\n失败项：' + this.atrDefUpdateErrors.join('；')
                : summary;
        },
        //新增
        async insertEvent (row) {
            console.log(row);
            let record
            record = {
                lid: 'lid',
                name: '联赛名',
                tag: 'tag',
                continents: 'continents',
                country: 'country',
                api_id: 0
            } 
            // 加入行, 表示加入行的row对象，row为空则插入第一行，为-1插入最后一行
            let { row: newRow } = await this.$refs.plxTable.insertRow(record, row)
            // 激活单元格编辑
            await this.$refs.plxTable.setActiveRow(newRow)
        },
        removeSelected(row){
            this.$refs.plxTable.remove(row);
        },
        //保存联赛数据更改
        async saveChg(){
            let chgData = [];
            chgData = this.$refs.plxTable.getTableData().tableData;
            console.log(chgData);
            chgData.map(obj => {
                delete obj._XID;
                delete obj.detail;
                // 将 id 的值转换为数字
                if (obj.id) {
                    obj.id = Number(obj.id);
                }
                return obj;
            });
            const postData = chgData
            console.log(postData);
            let url = updateSelectedLeaguesUrl;
            fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData)
            })
            .then(response => response.json())
            .then(data => {
                if (data.code === 200) {
                    //弹出成功提示
                    this.$alert('更新数据成功！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                }else{
                    //弹出失败提示
                    this.$alert('更新数据出错！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                }
            }).catch(error => {
                console.error('Error:', error);
                //弹出失败提示
                this.$alert('未知错误！更新数据失败！', '', {
                        confirmButtonText: '确定',
                });
            })
        },
        tabsClick(tab, event){
            console.log(tab, event);
        },
        searchId(){
            const id = this.teamId.trim();
            if (!id) {
                this.$message.error('请输入球队ID!');
                return;
            }
            this.fetchTeams(findTeamByIdUrl, 'id', id);
        },
        searchLeague(query){
            this.teamLeagueQuery = query || '';
        },
        handleLeagueDropdownChange(visible){
            if (visible && this.fbLeagues.length === 0 && !this.leagueListLoading) {
                this.getFbSelectedLeagues();
            }
        },
        handleLeagueCommand(league){
            this.teamLeagueQuery = league.name;
            this.fetchTeams(findTeamByLidUrl, 'lid', league.lid);
        },
        fetchTeams(endpoint, parameter, id){
            const requestId = ++this.teamSearchRequestId;
            this.teams = [];
            this.teamSearchError = false;
            this.teamSearchAttempted = true;
            this.teamSearchLoading = true;
            fetch(`${endpoint}?${parameter}=${encodeURIComponent(id)}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Team search request failed: ${response.status}`);
                }
                return response.json();
            })
            .then(result => {
                if (
                    result.code !== 200 ||
                    !Array.isArray(result.data) ||
                    !result.data.every(team =>
                        team && typeof team === 'object' && !Array.isArray(team)
                    )
                ) {
                    throw new Error('Team search response is invalid');
                }
                if (requestId === this.teamSearchRequestId) {
                    this.teams = result.data;
                }
            })
            .catch(err => {
                if (requestId === this.teamSearchRequestId) {
                    this.teamSearchError = true;
                    console.error(err);
                }
            })
            .finally(() => {
                if (requestId === this.teamSearchRequestId) {
                    this.teamSearchLoading = false;
                }
            });
        },
        async saveSelectedTeams(){
            if (this.teamSaveLoading) {
                return;
            }
            const selectedTeams = this.$refs.teamTable.getCheckboxRecords();
            if (selectedTeams.length === 0) {
                this.$message({
                    showClose: true,
                    type: 'warning',
                    message: '请选中至少一条数据!'
                });
                return;
            }

            this.teamSaveLoading = true;
            this.teamSaveDialogVisible = true;
            this.teamSaveCompleted = 0;
            this.teamSaveTotal = selectedTeams.length;
            this.teamSaveSuccess = 0;
            this.teamSaveFailed = 0;
            this.teamSaveResult = '';

            for (const team of selectedTeams) {
                const updateData = {
                    id: team.id,
                    name: team.name,
                    name_en: team.name_en,
                    name_tw: team.name_tw,
                    name_api: team.name_api,
                    api_id: team.api_id,
                    league: team.league,
                    lid: team.lid
                };
                try {
                    const response = await fetch(updateApiTeamUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(updateData)
                    });
                    if (!response.ok) {
                        throw new Error(`Team update request failed: ${response.status}`);
                    }
                    const result = await response.json();
                    if (result.code === 200 || result.msg === 'success') {
                        this.teamSaveSuccess++;
                    } else {
                        this.teamSaveFailed++;
                        console.error('Team update failed', team.id, result);
                    }
                } catch (err) {
                    this.teamSaveFailed++;
                    console.error('Team update failed', team.id, err);
                } finally {
                    this.teamSaveCompleted++;
                }
            }

            this.teamSaveLoading = false;
            this.teamSaveResult = `保存完成：${this.teamSaveSuccess} 条成功，${this.teamSaveFailed} 条失败`;
        },
        handleCountryDropdownChange(visible){
            if (visible) {
                this.loadApiCountries();
            }
        },
        async loadApiCountries(){
            if (this.countriesLoaded || this.countriesLoading) {
                return;
            }
            this.countriesLoading = true;
            this.countryLoadError = false;
            try {
                const response = await fetch(getApiCountryListUrl);
                if (!response.ok) {
                    throw new Error(`Country list request failed: ${response.status}`);
                }
                const data = await response.json();
                if (!Array.isArray(data.data)) {
                    throw new Error('Country list response is invalid');
                }
                this.countries = data.data.map(item => {
                    const value = typeof item === 'string'
                        ? item
                        : item.value || item.name || item.country || item.country_name || item.c_name;
                    return {
                        ...(typeof item === 'object' && item !== null ? item : {}),
                        value: String(value || '')
                    };
                }).filter(item => item.value);
                this.countriesLoaded = true;
            } catch (err) {
                this.countryLoadError = true;
                console.error(err);
            } finally {
                this.countriesLoading = false;
            }
        },
        async handleCommand(command){
            // console.log(command);
            this.country = command.value;
            this.countryQuery = command.value;
            this.apiLeagueQuery = '';
            this.apiLeagues = [];
            this.apiStandings = [];
            this.selectedApiLeague = '';
            this.apiStandingsError = false;
            this.apiStandingsRequestId++;
            this.apiStandingsLoading = false;
            this.apiLeaguesError = false;
            this.apiLeaguesLoading = false;
            const requestId = ++this.apiLeagueRequestId;
            const countryCode = command.name;
            if (!countryCode) {
                this.apiLeaguesError = true;
                console.error('Selected country is missing its country code', command);
                return;
            }

            this.apiLeaguesLoading = true;
            try {
                const url = `${getApiLeaguesByCountryCodeUrl}?code=${encodeURIComponent(countryCode)}`;
                console.log(url);                
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`League list request failed: ${response.status}`);
                }
                const result = await response.json();
                if (result.code !== 200 || !Array.isArray(result.data)) {
                    throw new Error('League list response is invalid');
                }
                if (requestId !== this.apiLeagueRequestId) {
                    return;
                }

                this.apiLeagues = result.data.map(item => {
                    const league = item.league || {};
                    const seasons = Array.isArray(item.seasons) ? item.seasons : [];
                    const season = seasons.find(entry => entry.current) || seasons[0];
                    return {
                        id: league.id,
                        name: league.name,
                        logo: league.logo,
                        type: league.type,
                        standing: season && season.coverage &&
                            typeof season.coverage.standings === 'boolean'
                            ? season.coverage.standings
                            : null
                    };
                });
            } catch (err) {
                if (requestId === this.apiLeagueRequestId) {
                    this.apiLeaguesError = true;
                    console.error(err);
                }
            } finally {
                if (requestId === this.apiLeagueRequestId) {
                    this.apiLeaguesLoading = false;
                }
            }
        },
        searchCountry(query){
            this.countryQuery = query || '';
        },
        searchApiLeague(query){
            this.apiLeagueQuery = query || '';
        },
        handleApiLeagueCommand(league){
            this.apiLeagueQuery = league.name;
            this.selectedApiLeague = league.name;
            this.getApiStandings(league);
        },
        async getApiStandings(league){
            const requestId = ++this.apiStandingsRequestId;
            this.apiStandings = [];
            this.apiStandingsError = false;
            this.apiStandingsLoading = true;
            try {
                const url = `${getApiStandingsUrl}?lid=${encodeURIComponent(league.id)}`;
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`Standings request failed: ${response.status}`);
                }
                const result = await response.json();
                if (result.code !== 200 || !Array.isArray(result.data)) {
                    throw new Error('Standings response is invalid');
                }
                if (requestId !== this.apiStandingsRequestId) {
                    return;
                }
                this.apiStandings = result.data.map(item => ({
                    played: item.all && item.all.played,
                    rank: item.rank,
                    teamId: item.team && item.team.id,
                    team: item.team && item.team.name,
                    teamLogo: item.team && item.team.logo,
                    goalsFor: item.all && item.all.goals && item.all.goals.for,
                    goalsAgain: item.all && item.all.goals && item.all.goals.against,
                    point: item.points
                }));
            } catch (err) {
                if (requestId === this.apiStandingsRequestId) {
                    this.apiStandingsError = true;
                    console.error(err);
                }
            } finally {
                if (requestId === this.apiStandingsRequestId) {
                    this.apiStandingsLoading = false;
                }
            }
        },
        handleCountryFlagError(event){
            event.target.style.visibility = 'hidden';
        },
        handleLeagueLogoError(event){
            event.target.style.visibility = 'hidden';
        },
    },
}
</script>
<style lang="scss" scoped>
    @import '../assets/sass/global.scss';

    .dropdown-menu-content {
        max-height: 300px;
        overflow-y: auto;
    }

    .team-search-input,
    .team-league-dropdown,
    .api-search-dropdown {
        width: 280px;
        margin-right: 16px;
    }

    .api-leagues-grid {
        width: 100%;
        min-height: 240px;
    }

    .api-league-tables {
        display: flex;
        gap: 12px;
        align-items: flex-start;
    }

    .api-league-table,
    .api-standings-table {
        width: 50%;
        min-width: 0;
    }

    @media (max-width: 767px) {
        .api-league-tables {
            flex-direction: column;
        }

        .api-league-table,
        .api-standings-table {
            width: 100%;
        }
    }

    .update-tabs ::v-deep .el-tabs__header {
        position: sticky;
        top: 0;
        z-index: 100;
        padding-top: 8px;
        background-color: #fff;
    }

    .update-tabs.is-dark ::v-deep .el-tabs__header {
        background-color: #0d1421;
    }

    .country-option {
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .country-flag-box {
        display: inline-block;
        width: 20px;
        height: 14px;
        border-radius: 2px;
        background-color: #dcdfe6;
        overflow: hidden;
        vertical-align: middle;
    }

    .country-flag {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .league-logo-box {
        display: inline-flex;
        width: 28px;
        height: 28px;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        // border-radius: 50%;
        // background-color: #dcdfe6;
        vertical-align: middle;
    }

    .league-logo {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .standings-team {
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .standings-team-logo-box {
        display: inline-flex;
        width: 24px;
        height: 24px;
        align-items: center;
        justify-content: center;
        flex: 0 0 24px;
        overflow: hidden;
        border-radius: 50%;
        background-color: #e4e7ed;
    }

    .standings-team-logo {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .selection-checkbox {
        display: inline-flex;
        align-items: center;
        position: relative;
        color: #606266;
        cursor: pointer;
        font-size: 14px;
        line-height: 1;
    }

    .selection-checkbox input {
        width: 14px;
        height: 14px;
        margin: 0 8px 0 0;
        opacity: 0;
        cursor: pointer;
    }

    .checkbox-icon {
        position: absolute;
        top: 0;
        left: 0;
        box-sizing: border-box;
        width: 14px;
        height: 14px;
        border: 1px solid #dcdfe6;
        border-radius: 2px;
        background: #fff;
        pointer-events: none;
    }

    .checkbox-icon.is-checked,
    .checkbox-icon.is-indeterminate {
        border-color: #409eff;
        background-color: #409eff;
    }

    .checkbox-icon.is-checked::after {
        position: absolute;
        top: 1px;
        left: 4px;
        box-sizing: content-box;
        width: 3px;
        height: 7px;
        border: 1px solid #fff;
        border-top: 0;
        border-left: 0;
        content: "";
        transform: rotate(45deg) scaleY(1);
    }

    .checkbox-icon.is-indeterminate::after {
        position: absolute;
        top: 5px;
        left: 3px;
        width: 6px;
        height: 2px;
        background: #fff;
        content: "";
    }

    .selection-checkbox input:focus-visible + .checkbox-icon {
        outline: 2px solid #a6d2ff;
        outline-offset: 1px;
    }

    .select-all {
        margin-bottom: 8px;
    }

    .league-checkbox {
        margin-right: 30px;
    }
</style>